/** Active or completed step node */
export const STEP_ACTIVE_COLOR = '#127A52';
/** Inactive step node */
export const STEP_INACTIVE_COLOR = '#D2D5DB';

/** Connector line when the step to the left is completed */
export const CONNECTOR_ACTIVE_COLOR = '#127A52';
/** Connector line when not yet completed */
export const CONNECTOR_INACTIVE_COLOR = '#D2D5DB';

/** Default node circle size (px) */
export const NODE_SIZE = 12;
/** Active step node is slightly larger in Figma */
export const NODE_SIZE_ACTIVE = 14;

/** Gap between connector segment and node (px) */
export const CONNECTOR_NODE_GAP = 4;

/** Connector thickness (px) */
export const CONNECTOR_HEIGHT = 2;

/** Space between nodes row and labels (px) */
export const LABEL_TOP_GAP = 8;

/** Label text when step is active or completed */
export const LABEL_ACTIVE_COLOR = '#131314';
/** Label text when step is inactive / upcoming (Figma — full dark text, not muted) */
export const LABEL_INACTIVE_COLOR = '#131314';
